module.exports = __webpack_public_path__ + "static/centimeter-5403d5d14d733ef11c42efacdcc9619d.png";